var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdditionalDocs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7895 25.9737H0V0H13.6053L19.7895 6.18421V25.9737Z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8633 6.80078H12.9883V0.925781L18.8633 6.80078Z",
    fill: "#E1F5FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94922 11.1328H15.4624V12.3697H4.94922V11.1328ZM4.94922 13.6065H12.9887V14.8433H4.94922V13.6065ZM4.94922 16.0802H15.4624V17.317H4.94922V16.0802ZM4.94922 18.5539H12.9887V19.7907H4.94922V18.5539Z",
    fill: "#1976D2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalDocs);
export default __webpack_public_path__ + "static/media/additional-docs.1e444508b02af8daf787a79bac822142.svg";
export { ForwardRef as ReactComponent };